import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import * as Icon from '@material-ui/icons';

const QBookmarkItemText = ({
    id,
    title,
    description,
    handleApplyBookmark,
    canDelete,
    handleDeleteBookmark,
}) => (
    <>
        <ListItemText onClick={() => handleApplyBookmark(id)}>
            {title}
            <br />
            <small>{description}</small>
        </ListItemText>
        {canDelete && (
            <ListItemIcon onClick={() => handleDeleteBookmark(id)}>
                <Icon.Delete />
            </ListItemIcon>
        )}
    </>
);

const QBookmarkItem = ({
    qBookmark,
    handleDeleteBookmark,
    handleApplyBookmark,
}) => {
    const canDelete = qBookmark?.qMeta?.privileges?.includes('delete');
    return (
        <ListItem button>
            <QBookmarkItemText
                id={qBookmark.qInfo.qId}
                title={qBookmark.qData.title}
                description={qBookmark.qData.title}
                handleApplyBookmark={handleApplyBookmark}
                handleDeleteBookmark={handleDeleteBookmark}
                canDelete={canDelete}
            />
        </ListItem>
    );
};

QBookmarkItemText.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
    canDelete: PropTypes.bool.isRequired,
    handleApplyBookmark: PropTypes.func.isRequired,
    handleDeleteBookmark: PropTypes.func.isRequired,
};

QBookmarkItem.propTypes = {
    qBookmark: PropTypes.object.isRequired,
    handleDeleteBookmark: PropTypes.func.isRequired,
    handleApplyBookmark: PropTypes.func.isRequired,
};

export default QBookmarkItem;
